<section class="privacy section-padding">
  <div class="container">
    <h1 class="title">Política de Cookies</h1>

    <p>
      Este site utiliza apenas os cookies necessários para seu funcionamento e os
      cookies de análise fornecidos pelo <strong>Google Analytics</strong>.
    </p>

    <p>
      Os dados coletados são anonimizados e tratados conforme a LGPD.
    </p>

    <p>
      Você pode desativar os cookies de análise nas configurações do navegador.
    </p>

    <p>
      Em caso de dúvidas, entre em contato:
      <a href="mailto:contato@casaaltasp.com.br">contato@casaaltasp.com.br</a>
    </p>
  </div>
</section>
